import { render } from "./projectCell.vue?vue&type=template&id=5bd65f78&scoped=true"
import script from "./projectCell.vue?vue&type=script&lang=js"
export * from "./projectCell.vue?vue&type=script&lang=js"

import "./projectCell.vue?vue&type=style&index=0&id=5bd65f78&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd65f78"]])

export default __exports__